import Marquee from "react-fast-marquee";

const ITEMS = [
  "Primary Packaging",
  "Shrink Wrapping",
  "Pallet Wrapper",
  "Inspection",
  "Secondary Packaging",
  "Pharmaceutical",
  "Palletizing",
  "Conveyor Systems",
];

export default function MarqueeStrip() {
  return (
    <section
      className="border-y border-white/10 bg-obsidian py-6 md:py-8 overflow-hidden"
      data-testid="marquee-strip"
      aria-hidden="true"
    >
      <Marquee speed={45} gradient={false} autoFill>
        {ITEMS.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display uppercase tracking-tight text-4xl md:text-6xl text-outline mx-8">
              {item}
            </span>
            <span className="h-3 w-3 rotate-45 bg-spartangreen mx-8" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
